import React from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./TransitionProposalDetailsSections.module.css";

const Section: React.FC<{ className?: string; children: React.ReactNode }> = ({
  children,
  className,
}) => {
  return (
    <div className={toClassName(styles.section, className)}>{children}</div>
  );
};

const SectionHeader: React.FC<{
  title: string | React.ReactNode;
  startComponent?: React.ReactNode;
  endComponent?: React.ReactNode;
  className?: string;
}> = ({ title, startComponent, endComponent, className }) => {
  return (
    <div className={toClassName(styles.sectionHeader, className)}>
      {startComponent && (
        <div className={styles.headerStartComponent}>{startComponent}</div>
      )}

      <div className={styles.headerTitle}>{title}</div>

      {endComponent && (
        <div className={styles.headerEndComponent}>{endComponent}</div>
      )}
    </div>
  );
};

const SectionBody: React.FC<{
  className?: string;
  children: React.ReactNode;
}> = ({ children, className }) => {
  return (
    <div className={toClassName(styles.sectionBody, className)}>{children}</div>
  );
};

const SubSection: React.FC<{
  title?: string;
  children: React.ReactNode;
  className?: string;
}> = ({ title, children, className }) => {
  return (
    <div className={toClassName(styles.subSection, className)}>
      {title && <div className={styles.subSectionTitle}>{title}</div>}
      <div className={styles.subSectionContent}>{children}</div>
    </div>
  );
};

export { Section, SectionBody, SectionHeader, SubSection };
